import {Component, Input, OnInit} from '@angular/core';
import {AhmService} from '../../services/ahm.service';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {TranslateService} from "../../services/translate.service";

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.css'],
    animations: [
        trigger('cabinet', [
          transition('void => *', [
            style({ transform: 'translateY(-100%)' }),
            animate(200)
          ])
        ]),
        trigger('reader', [
          transition('void => *', [
            style({ opacity: 0 }),
            animate(1500)
          ])
        ])
    ]
})
export class TopMenuComponent implements OnInit {

    navigationColor = 'white';
    navigationSize = 25; // size of contol elements font in pixeles
    navigationTextSize = 15;
    booksButtonMenuColor = 'white';
    booksButtonMenuText = 'books';
    aboutButtonMenuColor = 'white';
    aboutButtonMenuText = 'about';
    rightButtonMenuColor = 'white';
    leftButtonMenuColor = 'white';
    centerButtonMenuColor = 'white';
    instrumentsButtonMenuColor = 'white';
    instrumentsButtonMenuText = 'instruments';
    // convention news events
    newsButtonMenuColor = 'white';
    newsButtonMenuText = 'news';
    conventionButtonMenuColor = 'white';
    conventionButtonMenuText = 'convention';
    eventsButtonMenuColor = 'white';
    eventsButtonMenuText = 'events';
    cmmButtonMenuColor = 'white';
    psyButtonMenuColor = 'white';
    supportButtonMenuColor = 'white';
    whoButtonMenuColor = 'white';


    // controls
    // page number 1..N
    public currentPageAHM = 1;


    modeSwitched: string = 'cabinet';
    modes: string[] = ['cabinet', 'reader'];

    @Input() signedInSpan;
    @Input() signedInColor;
    @Input() signedInBgColor;

    constructor(private service: AhmService, private translate: TranslateService) {
    }

    ngOnInit() {
        this.service.setTopMenuComponentLink(this);
        this.service.translateComponent(this, 'app-top-menu');
    }

    loadEventsContent() {
        this.service.eventsContent();
    }

    loadFindPsyContent() {
        this.service.psyContent();
    }

    loadConventionContent() {
        this.service.conventionContent();
    }

    loadBooksContent() {
        this.service.buyContentBlock();
    }

    loadAboutContent() {
        this.service.loadAboutContent();
    }

    loadInstrumentsContent() {
        this.service.instrumentsContent();
    }

    loadNewsContent() {
        this.service.newsContentBlock();
    }

    loadCommunityContent() {
        this.service.communityContent();
    }

    loadSupportContent() {
        this.service.supportContent();
    }

    loadWhoElseContent() {
        this.service.whoelseContent();
    }

    /**
     * Click on top menu
     */
    menuItem(item) {

        // this.service.showPage(1);

        switch (item) {
            case 'books': {
                this.booksButtonMenuColor = 'orange';
                //
                // reset other colors TODO: refactor
                // this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'about': {
                this.aboutButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                // this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'left': {
                if (this.currentPageAHM > 1) {
                    this.currentPageAHM--;
                }
                let page = this.currentPageAHM;
                this.service.showPage(page);

                this.leftButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                // this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'right': {
                this.currentPageAHM++;
                let page = this.currentPageAHM;
                this.service.showPage(page);

                this.rightButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                // this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'center': {
                this.currentPageAHM = 1;
                let page = this.currentPageAHM;
                this.service.showPage(page);

                this.centerButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                // this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'instruments': {
                this.instrumentsButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                // this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'events': {
                this.eventsButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                // this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'convention': {
                this.conventionButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                // this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'news': {
                this.newsButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                // this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'community': {
                this.cmmButtonMenuColor = 'orange';
                //
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                // this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'findpsy': {
                this.cmmButtonMenuColor = 'orange';
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'orange';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'support': {
                this.cmmButtonMenuColor = 'orange';
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'orange';
                this.whoButtonMenuColor = 'white';
                break;
            }
            case 'whoelse': {
                this.cmmButtonMenuColor = 'white';
                this.booksButtonMenuColor = 'white';
                this.aboutButtonMenuColor = 'white';
                this.rightButtonMenuColor = 'white';
                this.leftButtonMenuColor = 'white';
                this.centerButtonMenuColor = 'white';
                this.instrumentsButtonMenuColor = 'white';
                this.conventionButtonMenuColor = 'white';
                this.eventsButtonMenuColor = 'white';
                this.newsButtonMenuColor = 'white';
                this.cmmButtonMenuColor = 'white';
                this.psyButtonMenuColor = 'white';
                this.supportButtonMenuColor = 'white';
                this.whoButtonMenuColor = 'orange';
                break;
            }
        }
    }

    /**
     * reset all menu colors
     */
    public resetMenuColors() {
        // this.booksButtonMenuColor = 'white';
        // this.booksButtonMenuColor = 'white';
        // this.aboutButtonMenuColor = 'white';
        // this.rightButtonMenuColor = 'white';
        // this.leftButtonMenuColor = 'white';
        // this.centerButtonMenuColor = 'white';
        // this.instrumentsButtonMenuColor = 'white';
        // this.conventionButtonMenuColor = 'white';
        // this.eventsButtonMenuColor = 'white';
        // this.newsButtonMenuColor = 'white';
        // this.cmmButtonMenuColor = 'white';
        // this.supportButtonMenuColor = 'white';
        // this.psyButtonMenuColor = 'white';
        // this.whoButtonMenuColor = 'white';
    }

    openLoginForm() {
        if ('<b>Not Signed In</br>' === this.signedInSpan) {
            this.service.showLoginForm();
        } else {
            // todo: visit cabinet
        }
    }

  setLanguage(language: string) {
    if ('ru' === language) {
      this.service.setLanguageSiteVersion('rus');
      this.translate.use('ru');
    }else if ('en' === language) {
      this.service.setLanguageSiteVersion('eng');
      this.translate.use('en');

    }
  }

    loadAppsContent() {
        this.service.appsContentBlock();
    }
}
